<template>
  <vue-aos animation-class="fadeInUp animated" style="animation-duration: 0.4s">
    <div class="story-image" :class="size">
      <a :href="src" target="_blank" class="story-image__wrapper">
        <img :src="src" />
      </a>
    </div>
  </vue-aos>
</template>

<script>
export default {
  name: 'story-image',
  props: {
    src: String,
    size: {
      type: String,
      required: false,
      default: "md"
    }
  }
}
</script>

<style scoped>
.story-image {
  /* padding: 0 2rem; */
  margin: 0 auto 2rem;
  /* width: fit-content; */
  background-color: #b19226;
  padding: .4rem;
}

.story-image.sm {
  max-width: 50%;
}

.story-image.md {
  max-width: 70%;
}

.story-image.lg {
  max-width: 90%;
}

.story-image .story-image__wrapper {
  display: block;
  position: relative;
  padding: .6rem;
}

.story-image .story-image__wrapper::before {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: '';
  background-color: #fff9;
  transform: rotateZ(-.5deg);
}

.story-image .story-image__wrapper>img {
  max-width: 100%;
  position: relative;
}
</style>
